import { render, staticRenderFns } from "./add-manager.vue?vue&type=template&id=3d541cd1&scoped=true&lang=pug&"
import script from "./add-manager.vue?vue&type=script&lang=js&"
export * from "./add-manager.vue?vue&type=script&lang=js&"
import style0 from "./add-manager.vue?vue&type=style&index=0&id=3d541cd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d541cd1",
  null
  
)

export default component.exports